import { SAVE_EXPORT_JOB } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/actionTypes";
import { EDIT_EXPORT_JOB } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/actionTypes";
import { SNACKBAR } from "@/store/actionTypes";
import { RE_COMPUTE_FOB_RELATED_ELEMENTS } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import { SET_EXPORT_JOB } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import { SET_EXPORT_JOB_ID } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import { SET_SBMAIN } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
export default {
  data() {
    return {
      savingExportJob: false,
      retrievingEditExportJob: false
    };
  },
  created() {
    window.addEventListener("beforeunload", this.handleBrowserUnmount);
  },
  mounted() {
    this.getEditExportJob();
  },
  methods: {
    handleBrowserUnmount() {
      window.localStorage.removeItem("exportJob");
      window.localStorage.removeItem("sbMain");
      window.localStorage.setItem("exportJob", JSON.stringify({ ...this.$store.getters.exportJob }));
      window.localStorage.setItem("sbMain", JSON.stringify({ ...this.$store.getters.sbMain }));
    },
    reComputeFobRelatedElements() {
      this.$store.commit(RE_COMPUTE_FOB_RELATED_ELEMENTS);
      return;
    },
    saveExportJob() {
      this.reComputeFobRelatedElements();
      const exportJob = { ...this.$store.getters.exportJob };
      exportJob.sbMain = { ...this.$store.getters.sbMain };
      const timePeriodId = this.$store.getters.globalTimePeriod;
      this.savingExportJob = true;
      const formData = {
        name: exportJob.sbMain.jobName,
        portLocation: exportJob.sbMain.portLocation,
        jobData: exportJob,
        //todo timeperiod
        timePeriodId: timePeriodId
      };
      this.$store
        .dispatch(SAVE_EXPORT_JOB, formData)
        .then(res => {
          if (res.status === "success") {
            this.$store.dispatch(SNACKBAR, {
              color: "primary",
              text: `Saved Successfully`
            });
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => (this.savingExportJob = false));
    },
    getEditExportJob() {
      // check if url consist of "invoice" and invoice id
      // if yes, redirect the user to InvoiceProducts page
      const isInvoicePage = window.location.href.indexOf("/invoice/") > -1;
      // a value globally needs to be set whenever user passes invoice products page
      // on page refresh that value will be null thus we will force redirect user back
      const isInvoiceProductsPagePassed = this.$store.getters.isInvoiceProductsPagePassed;
      if (isInvoicePage && isInvoiceProductsPagePassed !== undefined && isInvoiceProductsPagePassed === false) {
        this.$router.push({ name: "dashboard.export.invoice-products" });
        return;
      }
      const exportJobParamId = this.$route.params.exportJobId;
      // if it is not a new export job
      if (exportJobParamId !== "new") {
        // checking if exportJobId parameter is set
        const exportJobId = this.$store.state.ExportModuleStore.exportJobId;
        // if parameter is set then don't send the api query
        // if parameter is not set then call the api
        if (exportJobId === null) {
          this.retrievingEditExportJob = true;
          this.$store
            // passing 1 temporarily to get exportjob id 1
            .dispatch(EDIT_EXPORT_JOB, { exportJobId: exportJobParamId })
            .then(res => {
              if (res) {
                this.$store.commit(SET_EXPORT_JOB, { exportJob: res.job_data });
                this.$store.commit(SET_EXPORT_JOB_ID, { id: res.id });
                // this.exportJobData = res;
              }
            })
            .catch(err => {
              this.handleError(err);
            })
            .finally(() => {
              this.retrievingEditExportJob = false;
            });
        }
      } else {
        // if there is a 'new' keyword in url
        // means it is a new export job which either got refreshed or tab was closed
        let exportJob = window.localStorage.getItem("exportJob");
        let sbMain = window.localStorage.getItem("sbMain");
        if (exportJob && sbMain) {
          const exportJobFromLocalStorage = JSON.parse(exportJob);
          const sbMainFromLocalStorage = JSON.parse(sbMain);
          this.$store.commit(SET_EXPORT_JOB, { exportJob: exportJobFromLocalStorage });
          this.$store.commit(SET_SBMAIN, { sbMain: sbMainFromLocalStorage });
          this.$store.commit(SET_EXPORT_JOB_ID, { id: exportJobFromLocalStorage.id });
          window.localStorage.removeItem("exportJob");
          window.localStorage.removeItem("sbMain");
        }
      }
    }
  }
};
